
import React from 'react'
import { Link } from 'react-router-dom'

import logo from '../../images/logo.svg'
import './Header.css'
import { useLocation } from 'react-router-dom' //Link

import {CurrentUserContext} from '../../contexts/CurrentUserContext'

function Header({isLoggin, onSignOut}) {
  const [scrolling, setScrolling] = React.useState(false);

  const currentUser = React.useContext(CurrentUserContext)

  function handleSignOut() {
    onSignOut()
  }
  const location = useLocation();

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`header ${scrolling ? 'header_scrolling' : ''}`}>
      <div className="header__wrapper">
        <img src={logo} className="header__logo"></img>

        {!isLoggin && location.pathname === `/sign-in`
        ?<Link to={`/`} className="header__btn">Зарегистрироваться</Link>
        :isLoggin?
        <div className="header__container">
          <h3 className="header__greeting">Здравствуйте, {currentUser.username}</h3>
          <Link to={`/sign-in`} className="header__btn" onClick={handleSignOut}>Выйти</Link>
        </div>
        :<Link to={`/sign-in`} className="header__btn">Войти</Link>
      }
      </div>  

       
    </div>
  );
}

export default Header;

/*

        <div className="header__container">
          <h3 className="header__greeting">Здравствуйте, {currentUser}</h3>
          <Link to={`/sign-in`} className="header__btn" onClick={handleSignOut}>Выйти</Link>
        </div>
*/